import { FccAdAlertType } from '@backoffice-frontend/graphql'
import type { UseCallAlertsVehicleFragment } from './useCallAlerts.hook'

export const useCallAlerts = (vehicle: UseCallAlertsVehicleFragment) => {
  const vehicleAlerts = vehicle.fccCurrentAdAlerts?.alerts ?? []

  const alertsByType = vehicleAlerts.reduce(
    (acc, alert) => {
      acc[alert.type] = alert
      return acc
    },
    {} as Partial<Record<FccAdAlertType, (typeof vehicleAlerts)[0]>>,
  )

  const callRelatedTypes = [
    FccAdAlertType.IncomingPassengerCall,
    FccAdAlertType.OutgoingOperatorCall,
    FccAdAlertType.OutgoingOperatorToSafetyDriverCall,
    FccAdAlertType.IncomingSafetyDriverCall,
  ] as const

  const callAlertCreatedAt = callRelatedTypes
    .map(type => alertsByType[type]?.createdAt)
    .filter((createdAt): createdAt is string => Boolean(createdAt))
    .map(createdAt => new Date(createdAt))
    .sort((a, b) => a.getTime() - b.getTime())
    .at(0)

  const hasCallAlert = callRelatedTypes.some(
    type => alertsByType[type] !== undefined,
  )

  return {
    hasCallAlert,
    hasIncomingPassengerCallAlert:
      alertsByType[FccAdAlertType.IncomingPassengerCall] !== undefined,
    hasIncomingSafetyDriverCallAlert:
      alertsByType[FccAdAlertType.IncomingSafetyDriverCall] !== undefined,
    emergencyStopAlertId: alertsByType[FccAdAlertType.EmergencyStop]?.id,
    callAlertCreatedAt,
  }
}
